import { useMutation, useQueryClient } from 'react-query';
import { deleteRecognitionAsync } from 'services/Recognition';
import { RECOGNITION_KEYS } from 'services/Recognition/hooks/useQuery';
import { IRecognitionTypes } from '../../../types';
import {
  createStudentRecognitionAsync,
  createStudentRecognitionAsyncJob,
  deleteStudentRecognitionAsyncJob,
  getAllStudentsByLicenseAsync,
  getAllStudentsForSelectionAsync,
  getStudentRecognitionByIdAsync,
  setStudentTemporaryReleaseAsync,
  updateStudentRecognitionAsync,
  updateStudentRecognitionAsyncJob,
} from '../../index';
import { STUDENT_KEYS } from '../useQuery/index';
import { SCHOOL_CLASS_KEYS } from 'services/SchoolClass/hooks/useQuery';

export const useCreateStudentRecognitionAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(createStudentRecognitionAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([STUDENT_KEYS.ALL]);
    },
  });
};

export const useCreateStudentRecognitionAsyncJob = () => {
  const queryClient = useQueryClient();

  return useMutation(createStudentRecognitionAsyncJob, {
    onSuccess: () => {
      queryClient.invalidateQueries([STUDENT_KEYS.ALL]);
    },
  });
};

export const useUpdateStudentRecognitionAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(updateStudentRecognitionAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([STUDENT_KEYS.ALL]);
      queryClient.invalidateQueries([SCHOOL_CLASS_KEYS.ALL]);
    },
  });
};

export const useUpdateStudentRecognitionAsyncJob = () => {
  const queryClient = useQueryClient();

  return useMutation(updateStudentRecognitionAsyncJob, {
    onSuccess: () => {
      queryClient.invalidateQueries([STUDENT_KEYS.ALL]);
    },
  });
};

export const useDeleteStudentAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (id: number) => deleteRecognitionAsync({ id, type: IRecognitionTypes.STUDENT }), 
    {
      onSuccess: () => {
        queryClient.invalidateQueries([STUDENT_KEYS.ALL]);
        queryClient.invalidateQueries([RECOGNITION_KEYS.ALL]); 
      }
    }
  );
};

export const useDeleteStudentRecognitionAsyncJob = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteStudentRecognitionAsyncJob, {
    onSuccess: () => {
      queryClient.invalidateQueries([STUDENT_KEYS.ALL]);
      queryClient.invalidateQueries([RECOGNITION_KEYS.ALL]);
    },
  });
};

export const useGetStudentRecognitionByIdAsync = () =>
  useMutation(getStudentRecognitionByIdAsync);

export const useGetAllStudentsByLicenseMutateAsync = () =>
  useMutation(getAllStudentsByLicenseAsync);

export const useGetAllStudentsForSelectionMutateAsync = () => {
  return useMutation(getAllStudentsForSelectionAsync);
};

export const useSetStudentTemporaryReleaseAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(setStudentTemporaryReleaseAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([STUDENT_KEYS.ALL]);
      queryClient.invalidateQueries([RECOGNITION_KEYS.ALL]);
    },
  });
};